import type React from 'react';

import { Image } from '@change/ds-core-ui';

import { useDecisionMakerResponseMedia } from './hooks/useDecisionMakerResponseMedia';

export const DecisionMakerResponseMedia: React.FC<EmptyProps> = () => {
	const {
		data: { photo },
	} = useDecisionMakerResponseMedia();

	if (photo) {
		return (
			<div>
				<Image
					src={photo.url}
					aspectRatio="16:9"
					alt=""
					className="w-full rounded-md align-top md:w-[600px]"
					data-qa="dm-response-photo"
				/>
			</div>
		);
	}

	return null;
};
